export const isSolpedService = (code) => {
	if (!code) return false;
	return /^[A-Za-z]+$/.test(String(code).substring(0, 2));
};

export const getSolpedApprovalValidation = (items = []) => {
	const normalizedItems = Array.isArray(items) ? items : [];
	let missware = 0;
	let serviceCostZero = 0;

	normalizedItems.forEach((item) => {
		const code = item.code ?? item.item_code;
		const itemCost = Number(item.amou ?? 0) * Number(item.cost ?? 0);

		if (!item.ware) missware += 1;
		if (isSolpedService(code) && itemCost === 0) serviceCostZero += 1;
	});

	const reasons = [];
	if (missware > 0) {
		reasons.push(`Hay ${missware} elementos solicitados que no tienen almacén definido.`);
	}
	if (serviceCostZero > 0) {
		reasons.push(`Hay ${serviceCostZero} servicios solicitados que no tienen precio definido.`);
	}

	return {
		valid: reasons.length === 0,
		missware,
		serviceCostZero,
		reasons,
	};
};
